import React, {Component, ReactElement} from 'react'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {MainContainer} from '../../../styledComponents/ContentsArea'
import {DisplayBlockDiv} from '../../../styledComponents/DisplayItem'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {Nullable} from '../../../app/TypeHelpers'
import {Messages} from '../../../Messages'
import {Box} from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import NatSessionRepo from '../session/repository/NatSessionRepo'
import NatLoginRepo from './repository/NatLoginRepo'
import {NatAsyncCallFunction} from '../../common/util/Natutil'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {Colors, FontSize, FontWeights} from '../../../styledComponents/Constants'
import {AVAILABLE_SITE} from '../../../CodeMaster'
import {Phone} from '@mui/icons-material'
import MessageDialogComponent from '../../../common/resident/MessageDialogComponent'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
    residentLoginRepo: NatLoginRepo
    sessionRepo: NatSessionRepo
}

interface State {
    isLoadCompleted: boolean
    backgroundLoginSite: AVAILABLE_SITE
    isOpenMultipleLoginWarningDialog: boolean
}

class NatResidentAdLoginPage extends Component<Props & ResidentPagePropsSet, State> {
    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)
        this.state = {
            isLoadCompleted: false,
            backgroundLoginSite: AVAILABLE_SITE.NOT_LOGIN,
            isOpenMultipleLoginWarningDialog: false,
        }

        this.adLoginLinkClick = this.adLoginLinkClick.bind(this)
        this.handleCancelButtonClick = this.handleCancelButtonClick.bind(this)
        this.handleOkButtonClick = this.handleOkButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            // ログアウトボタンを押下せずにログイン画面へ遷移した場合はログアウト処理を行う。
            if (sessionStorage.length > 0) {
                await this.logoutProcedure()
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    async logoutProcedure(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            await NatAsyncCallFunction(this.props.residentLoginRepo.postLogout.bind(
                this.props.residentLoginRepo
            ), this.props.navigate)
            await NatAsyncCallFunction(this.props.sessionRepo.postResidentUseSite.bind(
                this.props.sessionRepo
            ), this.props.navigate)
            SessionStorageHelper.removeAllItem()
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    async adLoginLinkClick(): Promise<void> {
        const response = await NatAsyncCallFunction(
            this.props.sessionRepo.getLoginStatus.bind(this.props.sessionRepo),
            this.props.navigate,
        )
        if (response === null) {
            return
        }
        this.setState({
            backgroundLoginSite: AVAILABLE_SITE.codeToEnumConstants(response),
        })

        if (response === AVAILABLE_SITE.NOT_LOGIN.value) {
            this.adLogin()
        } else {
            this.setState({
                isOpenMultipleLoginWarningDialog: true,
            })
        }
    }

    handleCancelButtonClick(): void {
        this.setState({isOpenMultipleLoginWarningDialog: false})
    }

    async handleOkButtonClick(): Promise<void> {
        this.setState({isOpenMultipleLoginWarningDialog: false})
        await this.logoutProcedure()
        this.adLogin()
    }

    adLogin(): void {
        window.location.href = `/common/adSso/reception?useSite=2`
    }

    renderMultipleLoginWarningDialog(
        backgroundLoginSite: AVAILABLE_SITE,
        isOpenMultipleLoginWarningDialog: boolean
    ): Nullable<ReactElement> {
        let multipleLoginWarningDialogMessage
        if (backgroundLoginSite === AVAILABLE_SITE.ADMIN) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0001
        } else if (backgroundLoginSite === AVAILABLE_SITE.RESIDENT) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0002
        } else if (backgroundLoginSite === AVAILABLE_SITE.GUEST) {
            multipleLoginWarningDialogMessage = Messages.WOPCR0004
        } else {
            return null
        }

        return <MessageDialogComponent
            open={isOpenMultipleLoginWarningDialog}
            params={{
                title: '確認',
                errorLevel: multipleLoginWarningDialogMessage.errorLevel,
                message: multipleLoginWarningDialogMessage.toString(),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleCancelButtonClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleOkButtonClick,
                    },
                ],
            }}
        />
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <MainContainer>
                    <DisplayBlockDiv>
                        <PrimaryStyledButton
                            onClick={this.adLoginLinkClick}>
                            長谷工グループ認証で居住者画面へログイン
                        </PrimaryStyledButton>
                    </DisplayBlockDiv>
                </MainContainer>
                <Box height={'15px'}/>
                <LeftRowFlexContainer>
                    <Box width={'15px'}/>
                    <ContactArea>
                        <Box fontSize={FontSize.Middle}>ログインに関するお問い合わせ</Box>
                        <Box height={'10px'}/>
                        <Box fontSize={FontSize.Middle}>{Messages.IRESR0001.toString('')}</Box>
                        <Box height={'5px'}/>
                        <LeftRowFlexContainer>
                            <PhoneIcon fontSize={'large'}/>
                            <Box width={'10px'}/>
                            <Box fontSize={FontSize.Accent} fontWeight={FontWeights.Bold} color={Colors.AccentDark}>
                                {Messages.IRESR0002.toString()}
                            </Box>
                        </LeftRowFlexContainer>
                        <AlignItemsStartFlexContainer>
                            <Box>受付時間</Box>
                            <Box width={'10px'}/>
                            <Box>{Messages.IRESR0003.toString()}</Box>
                        </AlignItemsStartFlexContainer>
                    </ContactArea>
                </LeftRowFlexContainer>
                {this.renderMultipleLoginWarningDialog(
                    this.state.backgroundLoginSite,
                    this.state.isOpenMultipleLoginWarningDialog
                )}
            </>
        )
    }
}

export default createResidentPage(NatResidentAdLoginPage)

// お問い合わせ
const ContactArea: StyledDiv = styled.div`
  text-align: left;
`

const AlignItemsStartFlexContainer = styled(LeftRowFlexContainer)`
  align-items: flex-start;
  font-Size: ${FontSize.Small};
`

// 電話アイコン
const PhoneIcon = withStyles({
    root: {
        color: Colors.Primary,
    }
})(Phone)
